import { WelcomeStepProps } from '@/features/onboarding/types/onboarding.types';
import { Button } from '@chikara/ui';
import styles from '../Onboarding.module.css';
import { t } from '@/i18n';


export function WelcomeStep({ onSuccess }: WelcomeStepProps) {
    return (
        <div className={styles.stepContainer}>
            <h2 className={styles.title}>{t('onboarding.welcome.title')}</h2>
            <p className={styles.subtitle} style={{ marginBottom: '16px' }}>
                {t('onboarding.welcome.subtitle1')}
            </p>
            <p className={styles.subtitle} style={{ marginBottom: '32px' }}>
                {t('onboarding.welcome.subtitle2')}
            </p>

            <Button onClick={onSuccess} className={styles.submitButton} style={{ width: '100%' }}>
                {t('onboarding.action')}
            </Button>
        </div>
    );
}
